<template>
    <v-layout>
        <v-flex>                    
          <v-data-table
          :headers="headers"
          :items="relacion"        
          :search="search"
          class="elevation-1"
          >
          <template v-slot:[`item.activo`]="{ item }">  
              <div v-if="item.activo  ">
                  <span class="blue--text">Activo</span>
                  
              </div>
              <div v-else>
                  <span class="red--text">Inactivo</span>                
              </div>                  
          </template>
          <template v-slot:top>
              <v-toolbar flat color="white">
                  <v-toolbar-title>Relacion Cliente - Proveedor</v-toolbar-title>
                  <v-divider
                      class="mx-4"
                      inset
                      vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                  <v-spacer></v-spacer> 
                  <v-dialog v-model="dialog" max-width="500px">
                      <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                      </template>
                      <v-card>
                          <v-toolbar
                          color="primary"
                          dark
                          >
                          <span class="headline">Relacion Cliente - Proveedor</span>
                          <v-spacer></v-spacer>
                          <!--<v-switch
                          v-model="puertobase"
                          label="Puerto Base"
                          ></v-switch>-->
                          </v-toolbar>
                      <v-card-text>
                          <v-container>
                              <v-row>
                                  <v-col cols="12" sm="12" md="12">
                                      <v-select v-model="idcliente" :items="customer" label="Cliente">
                                      </v-select>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                      <v-select v-model="idproveedor" :items="provider" label="Proveedor">
                                      </v-select>
                                  </v-col>                    
                              </v-row>
                          </v-container>
                      </v-card-text>    
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                          <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                      </v-card-actions>
                      </v-card>
                  </v-dialog>

              </v-toolbar>
          </template>
          <template v-slot:[`item.opciones`]="{ item }">
              <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              >
              edit
              </v-icon>
              <template v-if="item.activo">                         
                     <v-icon
                      small
                      @click="activarDesactivarMostrar(2,item)"
                      >
                      block
                      </v-icon>                               
              </template>
              <template v-else>                         
                     <v-icon
                      small
                      @click="activarDesactivarMostrar(1,item)"
                      >
                      check
                      </v-icon>                               
              </template> 
          </template>   
          <template slot="no-data">
              <v-btn colo="primary" @click="listar">Resetear</v-btn>
          </template>     
          </v-data-table>                        
        </v-flex>
    </v-layout>
  </template>
  <script>
import axios from 'axios'      
export default {
    data(){
        return{
            idcliente:0,
            idproveedor:0,
            relacion:[], 
             adModal:false,            
             dialog: false,
                headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },                            
                { text: 'Cliente', value: 'ncliente' },
                { text: 'Proveedor', value: 'nproveedor', sortable: false }, 
                { text: 'Estado', value: 'activo' },                                          
                ],
                search:'',
                editedIndex: -1,              
                id:'',
                idpais:'',
                idpuerto:'',
                customer:[],
                provider:[],
                codigo:'',
                nombre:'',
                descripcion:'',                
                valida:'',
                validaMensaje:[],                
                adAccion:0,
                adNombre:'',
                adId:'',
                puertobase:false,
                
        }
    },
    computed: {
        /*formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'New Port' : 'Update Port'
        },*/
    },

    watch: {
        dialog (val) {
            val || this.close()
        },        
    },

    created () {        
        this.listar();
        this.select();
    },
    methods:{        
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Enlace_Cliente_Proveedor/ListarRelacion/',configuracion).then(function(response){
              me.relacion=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },
        select(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var customerArray = [];
            var providerArray = [];
            axios.get('api/Datos/SelectCliente',configuracion).then(function(response){            
                customerArray=response.data;
                customerArray.map(function(x){
                    me.customer.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Datos/SelectProveedor',configuracion).then(function(response){            
                providerArray=response.data;
                providerArray.map(function(x){
                    me.provider.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        editItem (item) {
            console.log(item)
            this.id=item.idpuerto;
            this.idpais=item.idpais;                       
            this.nombre=item.nombre;
            this.codigo=item.codigo;                        
            this.editedIndex=1;
            this.puertobase = item.puertobase;
            this.dialog = true
        },       
        close () {
            this.dialog = false;            
            this.limpiar();
        },
        limpiar(){
            this.idcliente = 0;
            this.idproveedor = 0;          
            this.editedIndex = -1;
        },
        guardar () {
            /*if(this.validar()){
                return;
            }*/
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            
            if (this.editedIndex > -1) {//codigo para editar            
                let me=this;                
                axios.put('api/Puertos/Actualizar',{
                    'idpuerto':me.id,
                    'idpais':me.idpais,                    
                    'nombre':me.nombre,
                    'puertobase':me.puertobase,
                    'codigo':me.codigo
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });  
            }else{//codigo para guardar
                let me=this;
                console.log('Entra Lista')
                console.log(me.idproveedor)
                axios.post('api/Enlace_Cliente_Proveedor/Crear',{
                    'idcliente':me.idcliente,
                    'idproveedor':me.idproveedor,
                    'activo':true,
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });                
            }            
        },
        validar(){
            this.valida=0;
            this.validaMensaje=[];

            if(this.nombre.length<3 || this.nombre.length>50){
                this.validaMensaje.push("El nombre debe tener mas de 3 caracteres y menos de 50 caracteres.");
            }
            if(!this.idpais){
                this.validaMensaje.push("Seleccione una Pais.");
            }            
            if(this.validaMensaje.length){
                this.valida=1;
            } 
            return this.valida;
        },
        activarDesactivarMostrar(accion,item){
           this.adModal=true;
           this.adNombre=item.nombre;
           this.adId=item.idpuerto;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModal=false;
            }
        },
        activarDesactivarCerrar(){
            this.adModal=false;
        },
        activar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Puertos/Activar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            }); 
        },
        desactivar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Puertos/Desactivar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>